import { type ReactElement } from 'react'
import { useTeamHierarchyContext } from '../../TeamHierarchyContext'
import { type TeamNodeContentProps } from './types'
import { PermissionNode } from './PermissionNode'
import { BasicNode } from './BasicNode'

export const TeamNodeContent = (props: TeamNodeContentProps): ReactElement => {
  const { withPermissions } = useTeamHierarchyContext()

  if (withPermissions) return <PermissionNode {...props} />

  return <BasicNode {...props} />
}
